export default function Footer() {
    return (
        <footer className="bg-sky-600 text-white px-6 py-10">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 text-sm">

                {/* Logo & Branding */}
                <div>
                    <div className="flex items-center gap-2 mb-2">
                        <img src="../image/Logo-AlamTrans.png" alt="Logo" className="h-20" />
                    </div>
                </div>

                {/* About Section */}
                <div>
                    <h4 className="font-semibold mb-2">About Alam Wisata Anugerah</h4>
                    <ul className="space-y-1 text-gray-100">
                        <li>How to Book</li>
                        <li>Contact Us</li>
                        <li>Help Center</li>
                        <li>About Us</li>
                    </ul>
                </div>

                {/* Products */}
                <div>
                    <h4 className="font-semibold mb-2">Products</h4>
                    <ul className="space-y-1 text-gray-100">
                        <li>Flights</li>
                        <li>Hotels</li>
                        <li>Travel Package</li>
                        <li>Cruises</li>
                        <li>Attractions</li>
                    </ul>
                </div>

                {/* Social Media */}
                <div>
                    <h4 className="font-semibold mb-2">Follow Us On</h4>
                    <ul className="space-y-1 text-gray-100">
                        <li>📷 Instagram</li>
                        <li>📺 YouTube</li>
                        <li>🎵 TikTok</li>
                        <li>📘 Facebook</li>
                        <li>🐦 Twitter</li>
                        <li>💬 WhatsApp</li>
                    </ul>
                </div>
            </div>
        </footer>
    );
}
